<template>
  <section class="drop-down-list">
    <div class="overlay" @click="closeAll"></div>
    <div
      :key="index"
      v-for="(step, index) in steps"
      class="question-container"
    >
      <h3 v-if="step.text">{{step.text}}</h3>
      <div class="image" v-if="step.image">
        <img :src="step.image" :key="step.image">
      </div>
      <kwt-basic-dropdown
        :id="index"
        :items="step.dropDownOptions"
        :on-select-item="handleSelectItem"
        :handle-open="handleOpen"
        :open-dropdown="openDropdown"
      ></kwt-basic-dropdown>
    </div>
  </section>
</template>

<script>
import KwtBasicDropdown from 'components/activity/KwtBasicDropdown.vue';

export default {
  components: {
    KwtBasicDropdown
  },
  props: {
    roundIndex: Number,
    steps: {
      type: Array,
      default: () => []
    },
    onSelectItem: {
      type: Function,
      default: () => () => {}
    }
  },
  data() {
    return {
      answers: {},
      openDropdown: null
    };
  },
  methods: {
    handleSelectItem({ isCorrectAnswer, text }, id) {
      this.answers[id] = { isCorrectAnswer, text };
      const completedSteps = Object.values(this.answers);

      this.openDropdown = null;

      if (completedSteps.length === this.steps.length) {
        this.onSelectItem('dropDownList', this.roundIndex, completedSteps);
      } else {
        this.onSelectItem('dropDownList', this.roundIndex);
      }
    },

    handleOpen(id) {
      if (this.openDropdown !== id) this.openDropdown = id;
      else this.openDropdown = null;
    },

    closeAll() {
      this.openDropdown = null;
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

.drop-down-list {
  display: flex;
  flex-flow: column nowrap;
  flex: 1;
  width: 100%;

  .question-container {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    width: 100%;
    padding: 12px 70px;

    h3,
    .image {
      padding: 20px;
      border: 2px solid black;
      flex: 1;
      text-align: center;
      margin-right: 20px;
    }

    .image {
      padding: 5px 20px;

      img {
        max-height: 50px;
      }
    }

    .kwt-basic-dropdown {
      width: 30%;
    }
  }
  .overlay {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
  }
}
</style>
